import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
import { SubscriptionService } from 'tnx-admin-service/workflowcore/subscription/services';
@Component({
    selector: 'subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['./subscription.component.scss'],
    providers: [ComponentContextService],
})
export class SubscriptionComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _subscriptionService: SubscriptionService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._subscriptionService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'persistenceId', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'eventKey', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'eventName', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'stepId', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'subscriptionId', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'workflowId', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'subscribeAsOf', dataType: 'date', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'code', name: '', fullName: '', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'persistenceId' }),
            new ColumnSchemaBase({ field: 'eventKey' }),
            new ColumnSchemaBase({ field: 'eventName' }),
            new ColumnSchemaBase({ field: 'stepId' }),
            new ColumnSchemaBase({ field: 'subscriptionId' }),
            new ColumnSchemaBase({ field: 'workflowId' }),
            new ColumnSchemaBase({ field: 'subscribeAsOf' }),
            new ColumnSchemaBase({ field: 'currentStateCode' }),
            new ColumnSchemaBase({ field: 'code' })
        ];

        super.ngOnInit();
    }
}

